import { render, staticRenderFns } from "./MailboxMessage.vue?vue&type=template&id=8f1c4576&scoped=true&"
import script from "./MailboxMessage.vue?vue&type=script&lang=js&"
export * from "./MailboxMessage.vue?vue&type=script&lang=js&"
import style0 from "./MailboxMessage.vue?vue&type=style&index=0&id=8f1c4576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c4576",
  null
  
)

export default component.exports